import clsx from "clsx";
import type React from "react";
import type { ReactNode } from "react";
import type { Status } from "~/models/Status";
import Styles from "./StatusBar.module.scss";

type Props = {
	currentId: number | null;
	statuses: Status[];
};

export const StatusBar: React.FC<Props> = ({ statuses, currentId }: Props) => {
	const displayStatuses = statuses.filter((s: Status) => s.statusBarDisplay);
	const renderStatus = (status: Status, index: number): ReactNode => (
		<div
			className={clsx(
				Styles.Status,
				status.id === currentId ? Styles.Active : "",
				index === 0 ? Styles.First : "",
				index === displayStatuses.length - 1 ? Styles.Last : ""
			)}
			key={status.id}
		>
			{status.name}
		</div>
	);
	return (
		<div className={Styles.StatusBar}>{displayStatuses.map(renderStatus)}</div>
	);
};
